import React from 'react';

import { FormattedMessageWrappedInSpan } from '../../misc';

const  EventSearchAltSearchResultsHint = () => {
  return (
    <div>
      <FormattedMessageWrappedInSpan
        id="eventSearchAltSearchResultsHint.instruction"
        defaultMessage="Click on the photos that show you and tag them with the <b>That's me</b> button."
        className="typography mt-10 mb-10"
        values={{
          b: (chunks) => <b>{chunks}</b>,
        }}
      />
    </div>
  );
}

export default EventSearchAltSearchResultsHint;
